var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"capcity-center"},[_c('img',{staticClass:"img",attrs:{"src":require("../assets/animation_capcity.gif"),"alt":"产能交易中心"}})])}]

export { render, staticRenderFns }